"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var Standard = "standard";
var MutedStandard = "mutedStandard";
var Hybrid = "hybrid";
var Satellite = "satellite";
var isOneOf = function isOneOf(value) {
  switch (value) {
    case Standard:
    case MutedStandard:
    case Hybrid:
    case Satellite:
      return true;
    default:
      return false;
  }
};
var _default = {
  Standard: Standard,
  MutedStandard: MutedStandard,
  Hybrid: Hybrid,
  Satellite: Satellite,
  isOneOf: isOneOf
};
exports["default"] = _default;